// angular
// 	.module("HeroPRO")
// 	.controller("ESignRedirectController", ESignRedirectController);

import './esign.scss';

/* @ngInject */
export default function ESignRedirectController($location, EDocUpdate) {
    const queryStringParams = $location.search();

    EDocUpdate.update(queryStringParams)
        .then(() => {
            $location.path(`/app-detail/${queryStringParams.FundingRequestId}`);
        });
}



// WEBPACK FOOTER //
// ./src/app/appDetail/ESign/ESignRedirectController.js